<template>
<div>
    <div class="login_wrap">
        <dl>
            <dt>회원가입</dt>
            <dd>
                프리북에 오신 것을 환영합니다.<br>
                먼저 성함을 알려주세요.
            </dd>
        </dl>
        <ul class="login_form">
            <li>
                <input type="text" v-model="authWrite.name" placeholder="이름">
            </li>
        </ul>
       
    </div>

    <div class="btn_box_fixed">
        <a class="default_btn1" @click="validate()" >다음</a>
    </div> 
</div>
    
</template>

<script>
export default {
    name:'JoinName',
    created() {
        this.$store.commit('SHOW_ONLOAD');
    },
    data() {
        return {
            authWrite: this.$store.state.auth.itemWrite,
        }
    },
    methods: {
        validate() {
            if(!this.authWrite.name) {
                this.$store.commit('OPEN_MODAL', {
                    content:'이름을 입력해주세요',
                    btnOne:'확인',
                })
                return;
            }
            this.submit();
        },

        submit(){
            this.$router.push('/join/niceAuth')
        }
    },
}
</script>

<style lang="scss" scoped>

</style>